document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-faq]').forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('.faq-item');
      const isOpen = item.classList.toggle('open');
      button.setAttribute('aria-expanded', String(isOpen));
    });
  });

  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      menu.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });
  }
});

// Predictive search
(() => {
  const widgets = document.querySelectorAll('[data-predictive-search]');
  widgets.forEach((widget) => {
    const input = widget.querySelector('[data-search-input]');
    const panel = widget.querySelector('[data-search-results]');
    const clear = widget.querySelector('[data-search-clear]');
    const endpoint = widget.dataset.predictiveUrl;
    if (!input || !panel || !endpoint) return;

    let timer;
    let controller;
    const close = () => {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    };
    const open = () => {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };
    const updateClear = () => { if (clear) clear.hidden = input.value.length === 0; };

    async function search(query) {
      if (controller) controller.abort();
      controller = new AbortController();
      panel.innerHTML = '<div class="predictive-loading">Zoeken naar de beste matches…</div>';
      open();
      try {
        const params = new URLSearchParams({
          q: query,
          'resources[type]': 'product,collection,page',
          'resources[limit]': '6',
          'resources[options][unavailable_products]': 'last',
          section_id: 'predictive-search'
        });
        const response = await fetch(`${endpoint}?${params.toString()}`, { signal: controller.signal });
        if (!response.ok) throw new Error('Search request failed');
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const section = doc.querySelector('#shopify-section-predictive-search');
        panel.innerHTML = section ? section.innerHTML : text;
        open();
      } catch (error) {
        if (error.name !== 'AbortError') {
          panel.innerHTML = '<div class="predictive-empty"><strong>Zoeken lukt tijdelijk niet</strong><p>Druk op Enter om de volledige zoekpagina te openen.</p></div>';
          open();
        }
      }
    }

    input.addEventListener('input', () => {
      const query = input.value.trim();
      updateClear();
      window.clearTimeout(timer);
      if (query.length < 2) { close(); return; }
      timer = window.setTimeout(() => search(query), 220);
    });
    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 2 && panel.innerHTML.trim()) open();
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { close(); input.blur(); }
      if (event.key === 'ArrowDown' && !panel.hidden) {
        const first = panel.querySelector('a');
        if (first) { event.preventDefault(); first.focus(); }
      }
    });
    panel.addEventListener('keydown', (event) => {
      const links = [...panel.querySelectorAll('a')];
      const index = links.indexOf(document.activeElement);
      if (event.key === 'ArrowDown' && index < links.length - 1) { event.preventDefault(); links[index + 1].focus(); }
      if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (index <= 0) input.focus(); else links[index - 1].focus();
      }
      if (event.key === 'Escape') { close(); input.focus(); }
    });
    if (clear) clear.addEventListener('click', () => {
      input.value = '';
      updateClear();
      close();
      input.focus();
    });
    document.addEventListener('click', (event) => { if (!widget.contains(event.target)) close(); });
    updateClear();
  });
})();

// Miko v12: AJAX cart drawer, filters, lightbox, sticky buy bar and recently viewed
(() => {
  const money = (cents) => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  const shell = document.querySelector('[data-cart-drawer-shell]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const itemsEl = document.querySelector('[data-cart-items]');
  const footerEl = document.querySelector('[data-cart-footer]');
  const totalEl = document.querySelector('[data-cart-total]');
  const toast = document.querySelector('[data-toast]');
  let lastFocus;

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message; toast.hidden = false;
    clearTimeout(showToast.timer); showToast.timer = setTimeout(() => { toast.hidden = true; }, 2600);
  }
  function openCart() {
    if (!shell || !drawer) return;
    lastFocus = document.activeElement; shell.hidden = false; document.body.classList.add('cart-open'); drawer.focus();
  }
  function closeCart() {
    if (!shell) return; shell.hidden = true; document.body.classList.remove('cart-open'); if (lastFocus) lastFocus.focus();
  }
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.classList.toggle('is-empty', cart.item_count === 0); });
    if (!itemsEl) return;
    if (!cart.item_count) {
      itemsEl.innerHTML = '<div class="cart-drawer__empty"><strong>Je winkelmand is leeg</strong><p>Ontdek een Miko Certified gaming-pc.</p><a class="btn btn-primary" href="/collections/all">Bekijk gaming-pc\'s</a></div>';
      if (footerEl) footerEl.hidden = true; return;
    }
    itemsEl.innerHTML = cart.items.map((item, index) => `<article class="drawer-item">
      <a href="${item.url}" class="drawer-item__image">${item.image ? `<img src="${item.image}" alt="">` : ''}</a>
      <div class="drawer-item__info"><a href="${item.url}"><strong>${item.product_title}</strong></a>${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${item.variant_title}</small>` : ''}
      <div class="drawer-item__bottom"><div class="qty-control"><button type="button" data-cart-change="${index+1}" data-quantity="${Math.max(0,item.quantity-1)}" aria-label="Eén minder">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${index+1}" data-quantity="${item.quantity+1}" aria-label="Eén meer">+</button></div><b>${money(item.final_line_price)}</b></div>
      <button class="drawer-remove" type="button" data-cart-change="${index+1}" data-quantity="0">Verwijderen</button></div></article>`).join('');
    if (totalEl) totalEl.textContent = money(cart.total_price); if (footerEl) footerEl.hidden = false;
  }
  async function getCart() { const r = await fetch('/cart.js'); const cart = await r.json(); renderCart(cart); return cart; }
  async function changeCart(line, quantity) { await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line,quantity})}); await getCart(); }

  document.addEventListener('click', async (e) => {
    const open = e.target.closest('[data-cart-open]'); if (open) { e.preventDefault(); await getCart(); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    const change = e.target.closest('[data-cart-change]'); if (change) { change.disabled=true; try { await changeCart(Number(change.dataset.cartChange),Number(change.dataset.quantity)); } finally { change.disabled=false; } }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && shell && !shell.hidden) closeCart(); });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-ajax-cart]'); if (!form) return;
    e.preventDefault(); const button=form.querySelector('[type="submit"]'); if(button){button.disabled=true;button.dataset.oldText=button.textContent;button.textContent='Toevoegen…';}
    try { const response=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)}); if(!response.ok) throw new Error(); await getCart(); openCart(); showToast('Toegevoegd aan je winkelmand'); }
    catch { showToast('Toevoegen is niet gelukt. Probeer opnieuw.'); }
    finally { if(button){button.disabled=false;button.textContent=button.dataset.oldText || 'In winkelwagen';} }
  });

  const filterToggle=document.querySelector('[data-filter-toggle]'), filterPanel=document.querySelector('[data-filter-panel]');
  if(filterToggle&&filterPanel) filterToggle.addEventListener('click',()=>{ const shown=filterPanel.classList.toggle('is-open'); filterToggle.textContent=shown?'Filters verbergen':'Filters tonen'; });

  document.querySelectorAll('[data-image-zoom]').forEach(btn=>btn.addEventListener('click',()=>{ const box=document.querySelector('[data-image-lightbox]'), img=box&&box.querySelector('[data-lightbox-image]'), source=btn.querySelector('img'); if(box&&img&&source){img.src=source.currentSrc||source.src;img.alt=source.alt;box.hidden=false;document.body.classList.add('lightbox-open');}}));
  document.querySelectorAll('[data-lightbox-close], [data-image-lightbox]').forEach(el=>el.addEventListener('click',e=>{if(e.target===el||el.hasAttribute('data-lightbox-close')){const box=document.querySelector('[data-image-lightbox]');if(box)box.hidden=true;document.body.classList.remove('lightbox-open');}}));

  const mobileAdd=document.querySelector('[data-mobile-add]'); if(mobileAdd) mobileAdd.addEventListener('click',()=>{const form=document.querySelector('.product-form--detail'); if(form) form.requestSubmit();});
  const variant=document.querySelector('[data-variant-select]'); if(variant) variant.addEventListener('change',()=>{const price=document.querySelector('[data-mobile-price]'), opt=variant.options[variant.selectedIndex];if(price)price.textContent=opt.dataset.price;});

  const recent=document.querySelector('[data-recently-viewed]');
  if(recent){try{const current={handle:recent.dataset.currentHandle,title:recent.dataset.currentTitle,url:recent.dataset.currentUrl,image:recent.dataset.currentImage,price:recent.dataset.currentPrice}, key='miko_recent_products';let list=JSON.parse(localStorage.getItem(key)||'[]').filter(p=>p.handle!==current.handle);const grid=recent.querySelector('[data-recent-grid]');if(grid&&list.length){grid.innerHTML=list.slice(0,4).map(p=>`<a class="recent-card" href="${p.url}"><img src="${p.image}" alt=""><span><strong>${p.title}</strong><b>${p.price}</b></span></a>`).join('');}else recent.hidden=true;list.unshift(current);localStorage.setItem(key,JSON.stringify(list.slice(0,6)));}catch(err){recent.hidden=true;}}
})();


// Miko v16: betrouwbare terugknoppen met veilige fallback.
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-page-back]');
  if (!button) return;
  event.preventDefault();
  var fallback = button.getAttribute('data-fallback-url') || '/';
  if (window.history.length > 1 && document.referrer && new URL(document.referrer).origin === window.location.origin) {
    window.history.back();
  } else {
    window.location.href = fallback;
  }
});


// Miko V58: scroll-reveal volledig verwijderd; content direct zichtbaar op alle schermen.
document.querySelectorAll('.reveal-on-scroll').forEach(el => {
  el.classList.remove('reveal-on-scroll');
  el.classList.add('is-visible');
});
